import { HexBoard, HexId, initialHexBoard } from 'features/hex-board/hex-board'

export type Piece = 'f' | 'w' | 'l' | 'kf' | 'kw' | 'kl' | 'F' | 'W' | 'L' | 'kF' | 'kW' | 'kL'
export type WhitePiece = Extract<Piece, 'f' | 'w' | 'l'>
export type BlackPiece = Extract<Piece, 'F' | 'W' | 'L'>
export type NonKingPiece = Extract<Piece, 'f' | 'w' | 'l' | 'F' | 'W' | 'L'>
export type KingPiece = Extract<Piece, 'kf' | 'kw' | 'kl' | 'kF' | 'kW' | 'kL'>
export type PlayerColor = 'white' | 'black'
export type HandPiece = NonKingPiece
export type Hand = HandPiece[]

export type GamePhase = 'distribute' | 'fight'

export type Kings = Record<PlayerColor, { piece: KingPiece | null; hexId: HexId | null }>

export type BoardState = {
  turn: PlayerColor
  hexBoard: HexBoard
  phase: GamePhase
  pieceCount: number
  switchRestrictions: [HexId, HexId][]
  kings: Kings
  kingMoved: {
    white: boolean
    black: boolean
  }
  fightClicks: {
    white: number
    black: number
  }
  hand: {
    white: Hand
    black: Hand
  }
}

export const initialBoardState: BoardState = {
  turn: 'white',
  hexBoard: initialHexBoard,
  phase: 'distribute',
  pieceCount: 0,
  fightClicks: {
    white: 0,
    black: 0,
  },
  kingMoved: {
    white: false,
    black: false,
  },
  kings: {
    black: {
      hexId: null,
      piece: null,
    },
    white: {
      hexId: null,
      piece: null,
    },
  },
  switchRestrictions: [],
  hand: {
    white: ['f', 'f', 'f', 'f', 'l', 'l', 'l', 'l', 'w', 'w', 'w', 'w'],
    black: ['F', 'F', 'F', 'F', 'L', 'L', 'L', 'L', 'W', 'W', 'W', 'W'],
  },
}
